export default "__VITE_PUBLIC_ASSET__eefb0377__"